import { UPLOADFILE_SUCCESS, UPLOADFILE_FAIL } from '../actions/types';

const initialState = [];

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPLOADFILE_SUCCESS:
      return { ...payload };

    case UPLOADFILE_FAIL:
      return { ...payload };

    default:
      return state;
  }
}
